import { VendersService } from '@/backend/market'
import { VenderRepository } from '../../domain/repositories/VenderRepository'
import { VenderModel } from '../models/VenderModel'
import type { VendersFilterEntity } from '../../domain/entities/VendersFilterEntity'
import { VendersFilterModel } from '../models/VendersFilterModel'
import { VenderResponseModel } from '../models/VenderResponseModel'
import type { VenderResponseEntity } from '../../domain/entities/VenderResponseEntity'
import type { VenderEntity } from '../../domain/entities/VenderEntity'
import type { CreateUpdateVenderEntity } from '../../domain/entities/CreateUpdateVenderEntity'
import { CreateUpdateVenderModel } from '../models/CreateUpdateVenderModel'

export class VenderRepositoryImpl implements VenderRepository {
  async getVenders(
    filterData: VendersFilterEntity
  ): Promise<VenderResponseEntity | { error: true }> {
    const vendersFilterModel = new VendersFilterModel(filterData)
    try {
      const response = await VendersService.getVendersAdmin(vendersFilterModel)
      const venderResponseModel = new VenderResponseModel(response)
      return venderResponseModel
    } catch {
      return { error: true }
    }
  }
  async getVenderById(id: number): Promise<VenderEntity | { error: true }> {
    try {
      const response = await VendersService.getVenderAdmin({
        id
      })
      const venderModel = new VenderModel(response)
      return venderModel
    } catch {
      return { error: true }
    }
  }
  async createVender(data: CreateUpdateVenderEntity): Promise<{ success: true } | { error: true }> {
    const createUpdateVenderModel = new CreateUpdateVenderModel(data)
    try {
      await VendersService.postVenderAdmin({
        requestBody: createUpdateVenderModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateVender(
    id: number,
    data: CreateUpdateVenderEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateVenderModel = new CreateUpdateVenderModel(data)
    try {
      await VendersService.putVenderAdmin({
        id,
        requestBody: createUpdateVenderModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteVender(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await VendersService.deleteVenderAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
